/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * eCFR SDK
 * TypeScript SDK and Model Context Protocol server for the Electronic Code of Federal Regulations (eCFR) API
 * OpenAPI spec version: 1.0.0
 */

import { GetApiAdminV1CorrectionsJsonParams,
GetApiSearchV1Results200,
GetApiSearchV1ResultsParams,
GetApiSearchV1CountParams,
GetApiSearchV1SummaryParams,
GetApiSearchV1CountsDailyParams,
GetApiSearchV1CountsTitlesParams,
GetApiSearchV1CountsHierarchyParams,
GetApiSearchV1SuggestionsParams,
GetApiVersionerV1AncestryDateTitleTitleJsonParams,
GetApiVersionerV1FullDateTitleTitleXmlParams,
GetApiVersionerV1VersionsTitleTitleJsonParams } from './http-schemas';

export type getApiAdminV1AgenciesJsonResponse200 = {
  data: void
  status: 200
}
    
export type getApiAdminV1AgenciesJsonResponseComposite = getApiAdminV1AgenciesJsonResponse200;
    
export type getApiAdminV1AgenciesJsonResponse = getApiAdminV1AgenciesJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiAdminV1AgenciesJsonUrl = () => {


  

  return `https://www.ecfr.gov/api/admin/v1/agencies.json`
}

export const getApiAdminV1AgenciesJson = async ( options?: RequestInit): Promise<getApiAdminV1AgenciesJsonResponse> => {
  
  const res = await fetch(getGetApiAdminV1AgenciesJsonUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiAdminV1AgenciesJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiAdminV1AgenciesJsonResponse
}



export type getApiAdminV1CorrectionsJsonResponse200 = {
  data: void
  status: 200
}

export type getApiAdminV1CorrectionsJsonResponse400 = {
  data: void
  status: 400
}
    
export type getApiAdminV1CorrectionsJsonResponseComposite = getApiAdminV1CorrectionsJsonResponse200 | getApiAdminV1CorrectionsJsonResponse400;
    
export type getApiAdminV1CorrectionsJsonResponse = getApiAdminV1CorrectionsJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiAdminV1CorrectionsJsonUrl = (params?: GetApiAdminV1CorrectionsJsonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/admin/v1/corrections.json?${stringifiedParams}` : `https://www.ecfr.gov/api/admin/v1/corrections.json`
}

export const getApiAdminV1CorrectionsJson = async (params?: GetApiAdminV1CorrectionsJsonParams, options?: RequestInit): Promise<getApiAdminV1CorrectionsJsonResponse> => {
  
  const res = await fetch(getGetApiAdminV1CorrectionsJsonUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiAdminV1CorrectionsJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiAdminV1CorrectionsJsonResponse
}



export type getApiAdminV1CorrectionsTitleTitleJsonResponse200 = {
  data: void
  status: 200
}

export type getApiAdminV1CorrectionsTitleTitleJsonResponse404 = {
  data: void
  status: 404
}
    
export type getApiAdminV1CorrectionsTitleTitleJsonResponseComposite = getApiAdminV1CorrectionsTitleTitleJsonResponse200 | getApiAdminV1CorrectionsTitleTitleJsonResponse404;
    
export type getApiAdminV1CorrectionsTitleTitleJsonResponse = getApiAdminV1CorrectionsTitleTitleJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiAdminV1CorrectionsTitleTitleJsonUrl = (title: string,) => {


  

  return `https://www.ecfr.gov/api/admin/v1/corrections/title/${title}.json`
}

export const getApiAdminV1CorrectionsTitleTitleJson = async (title: string, options?: RequestInit): Promise<getApiAdminV1CorrectionsTitleTitleJsonResponse> => {
  
  const res = await fetch(getGetApiAdminV1CorrectionsTitleTitleJsonUrl(title),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiAdminV1CorrectionsTitleTitleJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiAdminV1CorrectionsTitleTitleJsonResponse
}



export type getApiSearchV1ResultsResponse200 = {
  data: GetApiSearchV1Results200
  status: 200
}

export type getApiSearchV1ResultsResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1ResultsResponseComposite = getApiSearchV1ResultsResponse200 | getApiSearchV1ResultsResponse405;
    
export type getApiSearchV1ResultsResponse = getApiSearchV1ResultsResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1ResultsUrl = (params?: GetApiSearchV1ResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/results?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/results`
}

export const getApiSearchV1Results = async (params?: GetApiSearchV1ResultsParams, options?: RequestInit): Promise<getApiSearchV1ResultsResponse> => {
  
  const res = await fetch(getGetApiSearchV1ResultsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1ResultsResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1ResultsResponse
}



export type getApiSearchV1CountResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1CountResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1CountResponseComposite = getApiSearchV1CountResponse200 | getApiSearchV1CountResponse405;
    
export type getApiSearchV1CountResponse = getApiSearchV1CountResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1CountUrl = (params?: GetApiSearchV1CountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/count?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/count`
}

export const getApiSearchV1Count = async (params?: GetApiSearchV1CountParams, options?: RequestInit): Promise<getApiSearchV1CountResponse> => {
  
  const res = await fetch(getGetApiSearchV1CountUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1CountResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1CountResponse
}



export type getApiSearchV1SummaryResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1SummaryResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1SummaryResponseComposite = getApiSearchV1SummaryResponse200 | getApiSearchV1SummaryResponse405;
    
export type getApiSearchV1SummaryResponse = getApiSearchV1SummaryResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1SummaryUrl = (params?: GetApiSearchV1SummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/summary?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/summary`
}

export const getApiSearchV1Summary = async (params?: GetApiSearchV1SummaryParams, options?: RequestInit): Promise<getApiSearchV1SummaryResponse> => {
  
  const res = await fetch(getGetApiSearchV1SummaryUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1SummaryResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1SummaryResponse
}



export type getApiSearchV1CountsDailyResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1CountsDailyResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1CountsDailyResponseComposite = getApiSearchV1CountsDailyResponse200 | getApiSearchV1CountsDailyResponse405;
    
export type getApiSearchV1CountsDailyResponse = getApiSearchV1CountsDailyResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1CountsDailyUrl = (params?: GetApiSearchV1CountsDailyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/counts/daily?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/counts/daily`
}

export const getApiSearchV1CountsDaily = async (params?: GetApiSearchV1CountsDailyParams, options?: RequestInit): Promise<getApiSearchV1CountsDailyResponse> => {
  
  const res = await fetch(getGetApiSearchV1CountsDailyUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1CountsDailyResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1CountsDailyResponse
}



export type getApiSearchV1CountsTitlesResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1CountsTitlesResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1CountsTitlesResponseComposite = getApiSearchV1CountsTitlesResponse200 | getApiSearchV1CountsTitlesResponse405;
    
export type getApiSearchV1CountsTitlesResponse = getApiSearchV1CountsTitlesResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1CountsTitlesUrl = (params?: GetApiSearchV1CountsTitlesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/counts/titles?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/counts/titles`
}

export const getApiSearchV1CountsTitles = async (params?: GetApiSearchV1CountsTitlesParams, options?: RequestInit): Promise<getApiSearchV1CountsTitlesResponse> => {
  
  const res = await fetch(getGetApiSearchV1CountsTitlesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1CountsTitlesResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1CountsTitlesResponse
}



export type getApiSearchV1CountsHierarchyResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1CountsHierarchyResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1CountsHierarchyResponseComposite = getApiSearchV1CountsHierarchyResponse200 | getApiSearchV1CountsHierarchyResponse405;
    
export type getApiSearchV1CountsHierarchyResponse = getApiSearchV1CountsHierarchyResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1CountsHierarchyUrl = (params?: GetApiSearchV1CountsHierarchyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/counts/hierarchy?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/counts/hierarchy`
}

export const getApiSearchV1CountsHierarchy = async (params?: GetApiSearchV1CountsHierarchyParams, options?: RequestInit): Promise<getApiSearchV1CountsHierarchyResponse> => {
  
  const res = await fetch(getGetApiSearchV1CountsHierarchyUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1CountsHierarchyResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1CountsHierarchyResponse
}



export type getApiSearchV1SuggestionsResponse200 = {
  data: void
  status: 200
}

export type getApiSearchV1SuggestionsResponse405 = {
  data: void
  status: 405
}
    
export type getApiSearchV1SuggestionsResponseComposite = getApiSearchV1SuggestionsResponse200 | getApiSearchV1SuggestionsResponse405;
    
export type getApiSearchV1SuggestionsResponse = getApiSearchV1SuggestionsResponseComposite & {
  headers: Headers;
}

export const getGetApiSearchV1SuggestionsUrl = (params?: GetApiSearchV1SuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["agency_slugs[]"];

    if (value instanceof Array && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/search/v1/suggestions?${stringifiedParams}` : `https://www.ecfr.gov/api/search/v1/suggestions`
}

export const getApiSearchV1Suggestions = async (params?: GetApiSearchV1SuggestionsParams, options?: RequestInit): Promise<getApiSearchV1SuggestionsResponse> => {
  
  const res = await fetch(getGetApiSearchV1SuggestionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiSearchV1SuggestionsResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiSearchV1SuggestionsResponse
}



export type getApiVersionerV1AncestryDateTitleTitleJsonResponse200 = {
  data: void
  status: 200
}

export type getApiVersionerV1AncestryDateTitleTitleJsonResponse404 = {
  data: void
  status: 404
}
    
export type getApiVersionerV1AncestryDateTitleTitleJsonResponseComposite = getApiVersionerV1AncestryDateTitleTitleJsonResponse200 | getApiVersionerV1AncestryDateTitleTitleJsonResponse404;
    
export type getApiVersionerV1AncestryDateTitleTitleJsonResponse = getApiVersionerV1AncestryDateTitleTitleJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiVersionerV1AncestryDateTitleTitleJsonUrl = (date: string,
    title: string,
    params?: GetApiVersionerV1AncestryDateTitleTitleJsonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/versioner/v1/ancestry/${date}/title-${title}.json?${stringifiedParams}` : `https://www.ecfr.gov/api/versioner/v1/ancestry/${date}/title-${title}.json`
}

export const getApiVersionerV1AncestryDateTitleTitleJson = async (date: string,
    title: string,
    params?: GetApiVersionerV1AncestryDateTitleTitleJsonParams, options?: RequestInit): Promise<getApiVersionerV1AncestryDateTitleTitleJsonResponse> => {
  
  const res = await fetch(getGetApiVersionerV1AncestryDateTitleTitleJsonUrl(date,title,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiVersionerV1AncestryDateTitleTitleJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiVersionerV1AncestryDateTitleTitleJsonResponse
}



export type getApiVersionerV1FullDateTitleTitleXmlResponse200 = {
  data: string
  status: 200
}

export type getApiVersionerV1FullDateTitleTitleXmlResponse400 = {
  data: void
  status: 400
}
    
export type getApiVersionerV1FullDateTitleTitleXmlResponseComposite = getApiVersionerV1FullDateTitleTitleXmlResponse200 | getApiVersionerV1FullDateTitleTitleXmlResponse400;
    
export type getApiVersionerV1FullDateTitleTitleXmlResponse = getApiVersionerV1FullDateTitleTitleXmlResponseComposite & {
  headers: Headers;
}

export const getGetApiVersionerV1FullDateTitleTitleXmlUrl = (date: string,
    title: string,
    params?: GetApiVersionerV1FullDateTitleTitleXmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/versioner/v1/full/${date}/title-${title}.xml?${stringifiedParams}` : `https://www.ecfr.gov/api/versioner/v1/full/${date}/title-${title}.xml`
}

export const getApiVersionerV1FullDateTitleTitleXml = async (date: string,
    title: string,
    params?: GetApiVersionerV1FullDateTitleTitleXmlParams, options?: RequestInit): Promise<getApiVersionerV1FullDateTitleTitleXmlResponse> => {
  
  const res = await fetch(getGetApiVersionerV1FullDateTitleTitleXmlUrl(date,title,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiVersionerV1FullDateTitleTitleXmlResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiVersionerV1FullDateTitleTitleXmlResponse
}



export type getApiVersionerV1StructureDateTitleTitleJsonResponse200 = {
  data: void
  status: 200
}

export type getApiVersionerV1StructureDateTitleTitleJsonResponse404 = {
  data: void
  status: 404
}
    
export type getApiVersionerV1StructureDateTitleTitleJsonResponseComposite = getApiVersionerV1StructureDateTitleTitleJsonResponse200 | getApiVersionerV1StructureDateTitleTitleJsonResponse404;
    
export type getApiVersionerV1StructureDateTitleTitleJsonResponse = getApiVersionerV1StructureDateTitleTitleJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiVersionerV1StructureDateTitleTitleJsonUrl = (date: string,
    title: string,) => {


  

  return `https://www.ecfr.gov/api/versioner/v1/structure/${date}/title-${title}.json`
}

export const getApiVersionerV1StructureDateTitleTitleJson = async (date: string,
    title: string, options?: RequestInit): Promise<getApiVersionerV1StructureDateTitleTitleJsonResponse> => {
  
  const res = await fetch(getGetApiVersionerV1StructureDateTitleTitleJsonUrl(date,title),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiVersionerV1StructureDateTitleTitleJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiVersionerV1StructureDateTitleTitleJsonResponse
}



export type getApiVersionerV1TitlesJsonResponse200 = {
  data: void
  status: 200
}
    
export type getApiVersionerV1TitlesJsonResponseComposite = getApiVersionerV1TitlesJsonResponse200;
    
export type getApiVersionerV1TitlesJsonResponse = getApiVersionerV1TitlesJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiVersionerV1TitlesJsonUrl = () => {


  

  return `https://www.ecfr.gov/api/versioner/v1/titles.json`
}

export const getApiVersionerV1TitlesJson = async ( options?: RequestInit): Promise<getApiVersionerV1TitlesJsonResponse> => {
  
  const res = await fetch(getGetApiVersionerV1TitlesJsonUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiVersionerV1TitlesJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiVersionerV1TitlesJsonResponse
}



export type getApiVersionerV1VersionsTitleTitleJsonResponse200 = {
  data: void
  status: 200
}

export type getApiVersionerV1VersionsTitleTitleJsonResponse400 = {
  data: void
  status: 400
}
    
export type getApiVersionerV1VersionsTitleTitleJsonResponseComposite = getApiVersionerV1VersionsTitleTitleJsonResponse200 | getApiVersionerV1VersionsTitleTitleJsonResponse400;
    
export type getApiVersionerV1VersionsTitleTitleJsonResponse = getApiVersionerV1VersionsTitleTitleJsonResponseComposite & {
  headers: Headers;
}

export const getGetApiVersionerV1VersionsTitleTitleJsonUrl = (title: string,
    params?: GetApiVersionerV1VersionsTitleTitleJsonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://www.ecfr.gov/api/versioner/v1/versions/title-${title}.json?${stringifiedParams}` : `https://www.ecfr.gov/api/versioner/v1/versions/title-${title}.json`
}

export const getApiVersionerV1VersionsTitleTitleJson = async (title: string,
    params?: GetApiVersionerV1VersionsTitleTitleJsonParams, options?: RequestInit): Promise<getApiVersionerV1VersionsTitleTitleJsonResponse> => {
  
  const res = await fetch(getGetApiVersionerV1VersionsTitleTitleJsonUrl(title,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data: getApiVersionerV1VersionsTitleTitleJsonResponse['data'] = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as getApiVersionerV1VersionsTitleTitleJsonResponse
}


